import type { JourneyCommand } from "./journeyData";

function Bubble({ who, text, testId }: { who: "you" | "us"; text: string; testId: string }) {
  const you = who === "you";
  return (
    <div className={`flex ${you ? "justify-end" : "justify-start"}`}>
      <p data-testid={testId} className={`max-w-[92%] whitespace-pre-wrap break-words border-2 px-3 py-2 text-[13px] leading-snug ${you
        ? "border-[#C92E2B] bg-[#C92E2B] font-condensed text-base font-extrabold uppercase tracking-wide text-[#FFFFFF]"
        : "border-[#3A3F48] bg-[#171A1F] text-[#FFFFFF]"}`}>{text}</p>
    </div>
  );
}

/** When/how + variants + example and the live sample reply. Shared by the deck card and the directory. */
export function CommandInstructions({ c, prefix, compact = false }: { c: JourneyCommand; prefix: string; compact?: boolean }) {
  const variants = c.forms.filter((f) => f !== c.code);
  return (
    <div className="space-y-4 text-left">
      <dl className="space-y-3 text-sm">
        <div>
          <dt className="font-condensed text-xs font-extrabold uppercase tracking-[0.18em] text-[#F5D536]">When</dt>
          <dd className="mt-0.5 text-[#FFFFFF]" data-testid={`${prefix}-window-${c.slug}`}>{c.window}</dd>
        </div>
        {(variants.length > 0 || c.synonyms.length > 0) && (
          <div>
            <dt className="font-condensed text-xs font-extrabold uppercase tracking-[0.18em] text-[#F5D536]">Also send</dt>
            <dd className="mt-1 flex flex-wrap gap-1.5" data-testid={`${prefix}-variants-${c.slug}`}>
              {[...variants, ...c.synonyms].map((v) => (
                <span key={v} className="border-2 border-[#FFFFFF] px-2 py-0.5 font-condensed text-sm font-extrabold uppercase tracking-wide text-[#FFFFFF]">{v}</span>
              ))}
            </dd>
          </div>
        )}
      </dl>
      {!compact || c.example_reply ? (
        <div className="space-y-2" aria-label={`Example for ${c.code}`}>
          <p className="font-condensed text-xs font-extrabold uppercase tracking-[0.18em] text-[#F5D536]">Example</p>
          <Bubble who="you" text={c.example} testId={`${prefix}-example-${c.slug}`} />
          <Bubble who="us" text={c.example_reply} testId={`${prefix}-reply-${c.slug}`} />
          {c.follow_up_reply && <Bubble who="us" text={c.follow_up_reply} testId={`${prefix}-follow-up-${c.slug}`} />}
        </div>
      ) : null}
    </div>
  );
}
